var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsoTawa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 243.71",
    style: {
      enableBackground: "new 0 0 1080 243.71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#399AFF;}\n\t.st1{fill:#000064;}\n\t.st2{fill:#18C073;}\n\t.st3{fill:#FF455C;}\n\t.st4{fill:#FFB239;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.46,121.89c54.91,0,99.41-44.54,99.41-99.48h-46.6c0,29.18-23.66,52.8-52.81,52.8 c-29.2,0-52.83-23.62-52.83-52.8H27.01C27.01,77.35,71.53,121.89,126.46,121.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.64,221.3c0-29.14,23.63-52.81,52.83-52.81c29.14,0,52.81,23.66,52.81,52.81l0,0h46.6l0,0 c0-54.9-44.49-99.41-99.41-99.41c-54.93,0-99.46,44.51-99.46,99.41l0,0H73.64L73.64,221.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M677.85,22.44h-46.63c0,29.15-23.64,52.8-52.79,52.8v46.61C633.32,121.86,677.83,77.33,677.85,22.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M677.86,121.86V75.24c29.16,0,52.79-23.66,52.8-52.8h46.63C777.27,77.33,732.77,121.86,677.86,121.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M777.27,221.27h-46.61c-0.01-29.16-23.64-52.81-52.8-52.81v-46.6C732.77,121.86,777.27,166.36,777.27,221.27z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578.42,121.86v46.6c29.15,0,52.79,23.65,52.8,52.81h46.63C677.83,166.36,633.32,121.86,578.42,121.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M402.15,121.86h-46.64c0-29.18-23.64-52.81-52.79-52.81V22.43C357.62,22.43,402.14,66.95,402.15,121.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M402.15,22.43v46.62c29.17,0.01,52.8,23.63,52.8,52.81h46.63C501.56,66.95,457.05,22.43,402.15,22.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M501.58,221.28h-46.63c0-29.15-23.65-52.8-52.8-52.8v-46.62C457.05,121.86,501.56,166.37,501.58,221.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.72,121.86v46.62c29.15,0,52.79,23.65,52.79,52.8h46.64C402.14,166.37,357.62,121.86,302.72,121.86z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M953.55,22.42h-46.62c0,29.15-23.64,52.8-52.8,52.8v46.62C909.03,121.85,953.55,77.34,953.55,22.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1052.99,121.85V75.23c-29.16-0.01-52.79-23.65-52.81-52.8h-46.63 C953.56,77.34,998.08,121.85,1052.99,121.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M953.55,221.29h46.63c0.02-29.16,23.65-52.81,52.81-52.82v-46.63C998.08,121.85,953.57,166.37,953.55,221.29 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M854.13,121.85v46.63c29.16,0.01,52.8,23.65,52.8,52.82h46.62C953.55,166.37,909.03,121.85,854.13,121.85z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoTawa);
export default __webpack_public_path__ + "static/media/iso_tawa.f5deddb61182765ef37356a33c5833d2.svg";
export { ForwardRef as ReactComponent };